export const COST_CALC_REMOVE_ROW = "COST_CALC_REMOVE_ROW";
export const COST_CALC_SELECT_ROW = "COST_CALC_SELECT_ROW";